var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavoriteOffers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 257,
    viewBox: "0 0 283 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M281.494 256.003H1.50377C-4.76204 226.201 8.55348 194.782 41.4443 171.843C96.6999 133.308 186.298 133.308 241.558 171.843C274.449 194.782 287.765 226.201 281.494 256.003Z",
    fill: "#E6F3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M219.585 96.9582L144.396 53.7877V51.2414L219.585 94.4119V96.9582Z",
    fill: "#F2F6F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M139.135 86.0213L63.9463 42.8512V40.3044L139.135 83.475V86.0213Z",
    fill: "#F2F6F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M245.879 57.856L165.299 11.5463V9L245.879 55.3092V57.856Z",
    fill: "#F2F6F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M193.976 33.3281L165.298 16.8514V14.304L193.976 30.7813V33.3281Z",
    fill: "#F2F6F9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M126.788 38.1602L98.1104 21.6835V19.1372L126.788 35.6139V38.1602Z",
    fill: "#F2F6F9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6638 36.6079L59.4268 23.239V20.6921L82.6638 34.061V36.6079Z",
    fill: "#F2F6F9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M205.009 72.8807L111.009 18.8155V16.2692L205.009 70.3344V72.8807Z",
    fill: "#F2F6F9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M168.752 149.902L171.529 205.354C171.55 205.781 171.778 206.171 172.14 206.401C173.018 206.958 174.169 206.336 174.177 205.299L174.652 150.252C174.658 149.582 174.158 149.014 173.491 148.93L170.239 148.526C169.422 148.424 168.711 149.083 168.752 149.902Z",
    fill: "#369EFE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M174.156 148.931L172.973 205.869C172.973 207.003 175.448 206.743 176.368 206.076L176.553 205.942C176.893 205.695 177.104 205.309 177.125 204.89L179.938 149.705C179.972 149.036 179.521 148.438 178.866 148.284L175.869 147.58C174.994 147.375 174.156 148.036 174.156 148.931Z",
    fill: "#B4DBFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M204.776 137.219H204.779V134.785L202.741 134.014V134.827L116.474 84.9474C112.99 82.9329 108.71 82.8487 105.15 84.7252L52.7148 112.361L143.523 164.867C147.007 166.882 151.287 166.965 154.848 165.089L203.532 139.431C204.411 138.967 204.826 138.081 204.776 137.219Z",
    fill: "#369EFE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M143.519 162.149L52.7109 109.643L105.145 82.0072C108.706 80.1308 112.986 80.2144 116.469 82.2283L203.609 132.614C205.206 133.538 205.161 135.851 203.528 136.712L154.843 162.371C151.283 164.247 147.003 164.164 143.519 162.149Z",
    fill: "#B4DBFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M148.63 127.537L148.626 128.7L133.066 137.709L133.07 136.545L148.63 127.537Z",
    fill: "#E6F3FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M133.065 136.545L133.06 137.709L98.6211 117.9L98.6255 116.737L133.065 136.545Z",
    fill: "#E6F3FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M148.624 127.531L133.064 136.54L98.625 116.731L114.185 107.723L148.624 127.531Z",
    fill: "#F2F6F9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M116.292 109.995L116.29 110.677L114.137 111.924L114.139 111.241L116.292 109.995Z",
    fill: "#E6F3FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M114.138 111.239L114.136 111.922L112.012 110.7L112.014 110.018L114.138 111.239Z",
    fill: "#E6F3FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M116.293 109.99L114.14 111.237L112.016 110.015L114.169 108.77L116.293 109.99Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M119.015 111.561L119.012 112.244L116.859 113.49L116.862 112.808L119.015 111.561Z",
    fill: "#E6F3FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M116.861 112.806L116.859 113.488L114.734 112.266L114.737 111.584L116.861 112.806Z",
    fill: "#E6F3FF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M119.016 111.56L116.863 112.806L114.738 111.585L116.891 110.339L119.016 111.56Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M121.737 113.127L121.734 113.81L119.582 115.056L119.584 114.374L121.737 113.127Z",
    fill: "#E6F3FF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M119.58 114.372L119.577 115.054L117.453 113.833L117.455 113.15L119.58 114.372Z",
    fill: "#E6F3FF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M121.734 113.12L119.581 114.367L117.457 113.145L119.609 111.899L121.734 113.12Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M124.452 114.686L124.45 115.369L122.297 116.615L122.299 115.933L124.452 114.686Z",
    fill: "#E6F3FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M122.302 115.935L122.3 116.617L120.176 115.396L120.178 114.713L122.302 115.935Z",
    fill: "#E6F3FF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M124.457 114.685L122.304 115.932L120.18 114.71L122.333 113.464L124.457 114.685Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M127.175 116.256L127.173 116.939L125.02 118.185L125.022 117.503L127.175 116.256Z",
    fill: "#E6F3FF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M125.025 117.505L125.023 118.187L122.898 116.965L122.9 116.283L125.025 117.505Z",
    fill: "#E6F3FF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M127.176 116.253L125.023 117.499L122.898 116.277L125.051 115.031L127.176 116.253Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M129.897 117.818L129.895 118.5L127.742 119.748L127.744 119.065L129.897 117.818Z",
    fill: "#E6F3FF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M127.748 119.063L127.745 119.746L125.621 118.524L125.623 117.842L127.748 119.063Z",
    fill: "#E6F3FF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M129.898 117.819L127.745 119.065L125.621 117.843L127.774 116.597L129.898 117.819Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M132.616 119.384L132.614 120.066L130.461 121.313L130.463 120.631L132.616 119.384Z",
    fill: "#E6F3FF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M130.466 120.629L130.464 121.311L128.34 120.09L128.342 119.407L130.466 120.629Z",
    fill: "#E6F3FF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M132.617 119.381L130.464 120.628L128.34 119.406L130.493 118.159L132.617 119.381Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M135.343 120.951L135.341 121.633L133.188 122.88L133.19 122.198L135.343 120.951Z",
    fill: "#E6F3FF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M133.191 122.196L133.188 122.878L131.059 121.653L131.061 120.971L133.191 122.196Z",
    fill: "#E6F3FF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M135.34 120.954L133.188 122.201L131.059 120.975L133.211 119.729L135.34 120.954Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M138.061 122.515L138.059 123.197L135.906 124.445L135.908 123.763L138.061 122.515Z",
    fill: "#E6F3FF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M135.908 123.761L135.906 124.443L133.781 123.221L133.783 122.539L135.908 123.761Z",
    fill: "#E6F3FF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M138.059 122.521L135.906 123.767L133.781 122.545L135.934 121.299L138.059 122.521Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M140.78 124.079L140.777 124.761L138.625 126.008L138.627 125.326L140.78 124.079Z",
    fill: "#E6F3FF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M138.63 125.324L138.628 126.006L136.504 124.784L136.506 124.102L138.63 125.324Z",
    fill: "#E6F3FF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M140.781 124.079L138.628 125.326L136.504 124.104L138.656 122.858L140.781 124.079Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M146.226 127.207L146.223 127.89L144.07 129.136L144.072 128.454L146.226 127.207Z",
    fill: "#E6F3FF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M144.07 128.452L144.068 129.135L139.219 126.347L139.221 125.664L144.07 128.452Z",
    fill: "#E6F3FF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M146.225 127.212L144.071 128.459L139.223 125.669L141.376 124.424L146.225 127.212Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M116.272 113.15L116.27 113.833L114.117 115.08L114.119 114.397L116.272 113.15Z",
    fill: "#E6F3FF"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M114.117 114.393L114.115 115.075L109.266 112.286L109.268 111.604L114.117 114.393Z",
    fill: "#E6F3FF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M116.272 113.147L114.119 114.394L109.27 111.605L111.423 110.359L116.272 113.147Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M118.987 114.713L118.985 115.395L116.832 116.641L116.834 115.959L118.987 114.713Z",
    fill: "#E6F3FF"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M116.841 115.957L116.839 116.639L114.715 115.418L114.717 114.736L116.841 115.957Z",
    fill: "#E6F3FF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M118.992 114.712L116.839 115.958L114.715 114.737L116.867 113.491L118.992 114.712Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M121.706 116.279L121.704 116.961L119.551 118.207L119.553 117.525L121.706 116.279Z",
    fill: "#E6F3FF"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M119.556 117.523L119.553 118.205L117.43 116.984L117.431 116.302L119.556 117.523Z",
    fill: "#E6F3FF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M121.707 116.275L119.554 117.521L117.43 116.301L119.583 115.054L121.707 116.275Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M124.433 117.842L124.43 118.524L122.277 119.771L122.28 119.089L124.433 117.842Z",
    fill: "#E6F3FF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M122.283 119.09L122.28 119.773L120.156 118.552L120.158 117.869L122.283 119.09Z",
    fill: "#E6F3FF"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M124.437 117.842L122.284 119.088L120.16 117.867L122.313 116.62L124.437 117.842Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M127.155 119.407L127.153 120.089L125 121.337L125.002 120.655L127.155 119.407Z",
    fill: "#E6F3FF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M125.002 120.653L124.999 121.334L122.875 120.113L122.877 119.431L125.002 120.653Z",
    fill: "#E6F3FF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M127.152 119.411L124.999 120.658L122.875 119.436L125.027 118.19L127.152 119.411Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M129.874 120.971L129.872 121.652L127.719 122.9L127.72 122.218L129.874 120.971Z",
    fill: "#E6F3FF"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M127.72 122.219L127.718 122.901L125.594 121.679L125.596 120.997L127.72 122.219Z",
    fill: "#E6F3FF"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M129.871 120.97L127.717 122.217L125.594 120.995L127.746 119.749L129.871 120.97Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M132.597 122.539L132.594 123.221L130.441 124.468L130.444 123.786L132.597 122.539Z",
    fill: "#E6F3FF"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M130.443 123.787L130.442 124.469L128.312 123.245L128.314 122.562L130.443 123.787Z",
    fill: "#E6F3FF"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M132.598 122.543L130.446 123.79L128.316 122.565L130.469 121.318L132.598 122.543Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M135.319 124.102L135.317 124.784L133.164 126.031L133.166 125.349L135.319 124.102Z",
    fill: "#E6F3FF"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M133.166 125.347L133.163 126.029L131.039 124.808L131.041 124.125L133.166 125.347Z",
    fill: "#E6F3FF"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M135.316 124.103L133.163 125.349L131.039 124.127L133.192 122.881L135.316 124.103Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M138.038 125.664L138.036 126.347L135.883 127.593L135.884 126.911L138.038 125.664Z",
    fill: "#E6F3FF"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M135.884 126.913L135.882 127.595L133.758 126.374L133.76 125.691L135.884 126.913Z",
    fill: "#E6F3FF"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M138.035 125.668L135.882 126.915L133.758 125.693L135.911 124.447L138.035 125.668Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M140.761 127.23L140.758 127.912L138.605 129.16L138.607 128.478L140.761 127.23Z",
    fill: "#E6F3FF"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M138.607 128.478L138.606 129.161L136.477 127.936L136.478 127.254L138.607 128.478Z",
    fill: "#E6F3FF"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M140.759 127.235L138.606 128.481L136.477 127.257L138.63 126.01L140.759 127.235Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M143.483 128.796L143.481 129.478L141.328 130.724L141.33 130.042L143.483 128.796Z",
    fill: "#E6F3FF"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M141.326 130.042L141.324 130.723L139.199 129.503L139.201 128.819L141.326 130.042Z",
    fill: "#E6F3FF"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M143.48 128.801L141.327 130.048L139.203 128.826L141.356 127.579L143.48 128.801Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M113.526 114.736L113.524 115.418L111.371 116.665L111.373 115.983L113.526 114.736Z",
    fill: "#E6F3FF"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M111.375 115.986L111.373 116.668L106.523 113.879L106.526 113.197L111.375 115.986Z",
    fill: "#E6F3FF"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M113.528 114.738L111.376 115.985L106.527 113.195L108.68 111.949L113.528 114.738Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M116.249 116.302L116.247 116.984L114.094 118.23L114.096 117.548L116.249 116.302Z",
    fill: "#E6F3FF"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M114.091 117.55L114.089 118.232L111.965 117.011L111.966 116.329L114.091 117.55Z",
    fill: "#E6F3FF"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M116.246 116.298L114.093 117.545L111.969 116.324L114.121 115.078L116.246 116.298Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M118.964 117.865L118.962 118.548L116.809 119.794L116.811 119.112L118.964 117.865Z",
    fill: "#E6F3FF"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M116.814 119.114L116.812 119.796L114.688 118.575L114.69 117.892L116.814 119.114Z",
    fill: "#E6F3FF"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M118.969 117.865L116.816 119.111L114.691 117.889L116.844 116.643L118.969 117.865Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M121.69 119.431L121.688 120.112L119.535 121.36L119.537 120.678L121.69 119.431Z",
    fill: "#E6F3FF"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M119.537 120.683L119.534 121.365L117.41 120.143L117.412 119.461L119.537 120.683Z",
    fill: "#E6F3FF"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M121.687 119.435L119.534 120.681L117.41 119.459L119.563 118.213L121.687 119.435Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M124.409 120.997L124.407 121.679L122.254 122.926L122.256 122.244L124.409 120.997Z",
    fill: "#E6F3FF"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M122.255 122.242L122.253 122.924L120.129 121.703L120.131 121.02L122.255 122.242Z",
    fill: "#E6F3FF"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M124.41 120.997L122.257 122.244L120.133 121.022L122.286 119.776L124.41 120.997Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M127.128 122.562L127.126 123.244L124.973 124.491L124.975 123.809L127.128 122.562Z",
    fill: "#E6F3FF"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M124.978 123.807L124.976 124.489L122.852 123.268L122.853 122.585L124.978 123.807Z",
    fill: "#E6F3FF"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M127.129 122.563L124.976 123.81L122.852 122.588L125.004 121.342L127.129 122.563Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M129.854 124.125L129.852 124.807L127.699 126.054L127.701 125.373L129.854 124.125Z",
    fill: "#E6F3FF"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M127.698 125.374L127.696 126.056L125.566 124.832L125.569 124.148L127.698 125.374Z",
    fill: "#E6F3FF"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M129.852 124.129L127.7 125.376L125.57 124.151L127.723 122.905L129.852 124.129Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M132.573 125.691L132.571 126.374L130.418 127.62L130.42 126.938L132.573 125.691Z",
    fill: "#E6F3FF"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M130.419 126.94L130.417 127.622L128.293 126.401L128.295 125.718L130.419 126.94Z",
    fill: "#E6F3FF"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M132.574 125.692L130.421 126.938L128.297 125.716L130.45 124.47L132.574 125.692Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M135.292 127.254L135.29 127.936L133.137 129.182L133.139 128.5L135.292 127.254Z",
    fill: "#E6F3FF"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M133.142 128.504L133.14 129.186L131.016 127.965L131.017 127.282L133.142 128.504Z",
    fill: "#E6F3FF"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M135.293 127.255L133.14 128.501L131.016 127.279L133.169 126.033L135.293 127.255Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M140.733 130.387L140.731 131.069L138.578 132.315L138.58 131.633L140.733 130.387Z",
    fill: "#E6F3FF"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M138.581 131.631L138.579 132.313L133.73 129.525L133.732 128.843L138.581 131.631Z",
    fill: "#E6F3FF"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M140.736 130.388L138.583 131.634L133.734 128.846L135.887 127.599L140.736 130.388Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M113.495 117.892L113.493 118.574L111.34 119.822L111.342 119.139L113.495 117.892Z",
    fill: "#E6F3FF"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M111.347 119.14L111.345 119.822L103.777 115.47L103.779 114.787L111.347 119.14Z",
    fill: "#E6F3FF"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M113.498 117.894L111.345 119.14L103.777 114.788L105.93 113.542L113.498 117.894Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M116.214 119.461L116.211 120.143L114.059 121.39L114.061 120.707L116.214 119.461Z",
    fill: "#E6F3FF"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M114.064 120.705L114.061 121.388L111.938 120.166L111.939 119.484L114.064 120.705Z",
    fill: "#E6F3FF"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M116.215 119.457L114.062 120.704L111.938 119.483L114.09 118.237L116.215 119.457Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M118.94 121.028L118.938 121.71L116.785 122.957L116.787 122.275L118.94 121.028Z",
    fill: "#E6F3FF"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M116.787 122.269L116.784 122.951L114.66 121.73L114.662 121.047L116.787 122.269Z",
    fill: "#E6F3FF"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M118.937 121.025L116.784 122.272L114.66 121.05L116.813 119.803L118.937 121.025Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M121.659 122.585L121.657 123.267L119.504 124.515L119.506 123.833L121.659 122.585Z",
    fill: "#E6F3FF"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M119.509 123.835L119.507 124.517L117.383 123.295L117.385 122.613L119.509 123.835Z",
    fill: "#E6F3FF"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M121.66 122.59L119.507 123.837L117.383 122.615L119.536 121.369L121.66 122.59Z",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M124.378 124.148L124.375 124.832L122.223 126.078L122.224 125.396L124.378 124.148Z",
    fill: "#E6F3FF"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M122.224 125.398L122.222 126.08L120.098 124.858L120.1 124.176L122.224 125.398Z",
    fill: "#E6F3FF"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M124.379 124.153L122.225 125.4L120.102 124.178L122.254 122.932L124.379 124.153Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M127.104 125.718L127.102 126.4L124.949 127.647L124.951 126.965L127.104 125.718Z",
    fill: "#E6F3FF"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M124.951 126.967L124.95 127.649L122.82 126.424L122.822 125.741L124.951 126.967Z",
    fill: "#E6F3FF"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M127.103 125.722L124.95 126.969L122.82 125.744L124.973 124.497L127.103 125.722Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M129.823 127.282L129.82 127.964L127.668 129.211L127.67 128.529L129.823 127.282Z",
    fill: "#E6F3FF"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M127.673 128.531L127.671 129.213L125.547 127.992L125.549 127.309L127.673 128.531Z",
    fill: "#E6F3FF"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M129.824 127.286L127.671 128.533L125.547 127.311L127.7 126.064L129.824 127.286Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M132.542 128.847L132.54 129.529L130.387 130.775L130.388 130.093L132.542 128.847Z",
    fill: "#E6F3FF"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M130.388 130.095L130.386 130.777L128.262 129.556L128.264 128.874L130.388 130.095Z",
    fill: "#E6F3FF"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M132.543 128.852L130.389 130.098L128.266 128.877L130.419 127.63L132.543 128.852Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M137.983 131.979L137.981 132.662L135.828 133.909L135.83 133.227L137.983 131.979Z",
    fill: "#E6F3FF"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M135.831 133.225L135.829 133.907L130.98 131.119L130.982 130.437L135.831 133.225Z",
    fill: "#E6F3FF"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M137.987 131.977L135.833 133.225L130.984 130.436L133.137 129.189L137.987 131.977Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M105.311 116.352L105.309 117.034L103.156 118.281L103.158 117.599L105.311 116.352Z",
    fill: "#E6F3FF"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M103.154 117.596L103.152 118.278L101.027 117.057L101.03 116.375L103.154 117.596Z",
    fill: "#E6F3FF"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M105.309 116.352L103.156 117.598L101.031 116.377L103.184 115.131L105.309 116.352Z",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M108.03 117.915L108.028 118.598L105.875 119.844L105.877 119.161L108.03 117.915Z",
    fill: "#E6F3FF"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M105.88 119.163L105.878 119.846L103.754 118.624L103.756 117.942L105.88 119.163Z",
    fill: "#E6F3FF"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M108.031 117.919L105.878 119.165L103.754 117.944L105.907 116.698L108.031 117.919Z",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M110.753 119.484L110.751 120.166L108.598 121.413L108.6 120.731L110.753 119.484Z",
    fill: "#E6F3FF"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M108.599 120.729L108.597 121.411L106.473 120.19L106.475 119.507L108.599 120.729Z",
    fill: "#E6F3FF"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M110.75 119.485L108.597 120.732L106.473 119.51L108.626 118.264L110.75 119.485Z",
    fill: "white"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M124.358 127.305L124.356 127.988L122.203 129.234L122.205 128.552L124.358 127.305Z",
    fill: "#E6F3FF"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M122.206 128.554L122.204 129.236L109.191 121.752L109.194 121.07L122.206 128.554Z",
    fill: "#E6F3FF"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M124.36 127.306L122.208 128.553L109.195 121.068L111.348 119.823L124.36 127.306Z",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M127.081 128.874L127.079 129.556L124.926 130.802L124.928 130.12L127.081 128.874Z",
    fill: "#E6F3FF"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M124.923 130.118L124.921 130.8L122.797 129.579L122.799 128.897L124.923 130.118Z",
    fill: "#E6F3FF"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M127.078 128.874L124.925 130.12L122.801 128.899L124.954 127.652L127.078 128.874Z",
    fill: "white"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M129.796 130.437L129.794 131.119L127.641 132.365L127.643 131.683L129.796 130.437Z",
    fill: "#E6F3FF"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M127.646 131.681L127.644 132.363L125.52 131.142L125.521 130.46L127.646 131.681Z",
    fill: "#E6F3FF"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M129.801 130.433L127.648 131.68L125.523 130.458L127.676 129.211L129.801 130.433Z",
    fill: "white"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M135.241 133.569L135.239 134.251L133.086 135.497L133.088 134.815L135.241 133.569Z",
    fill: "#E6F3FF"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M133.09 134.814L133.088 135.496L128.238 132.708L128.24 132.026L133.09 134.814Z",
    fill: "#E6F3FF"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M135.241 133.566L133.088 134.812L128.238 132.024L130.391 130.777L135.241 133.566Z",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M101.598 109.016L83.6797 98.7117L109.019 84.1373L126.937 94.4424L101.598 109.016Z",
    fill: "white"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M101.957 105.527L85.7773 96.222L108.659 83.0615L124.838 92.3668L101.957 105.527Z",
    fill: "#00DD9B"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M139.823 120.225L128.135 113.502C127.382 113.069 127.382 111.988 128.135 111.555L141.444 103.901L156.445 112.529L143.065 120.225C142.062 120.802 140.826 120.802 139.823 120.225Z",
    fill: "#369EFE"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M120.796 51.4147L119.086 52.5663L120.748 94.6975L174.998 127.75L176.551 126.712C176.792 126.55 176.937 126.28 176.937 125.991V84.1817C176.937 83.7071 176.683 83.2682 176.27 83.0307L121.284 51.3982C121.131 51.3102 120.942 51.3162 120.796 51.4147Z",
    fill: "#369EFE"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M174.331 84.0821C174.845 84.3779 175.162 84.924 175.162 85.5147V127.314C175.162 127.692 174.751 127.928 174.423 127.739L120.283 96.5963C119.472 96.13 118.973 95.2676 118.973 94.3344V52.8401C118.973 52.5728 119.263 52.4056 119.495 52.5392",
    fill: "#0486FE"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M118.973 87.8622V54.3494L175.089 86.6374L175.161 120.184L118.973 87.8622Z",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M128.385 93.1877L125.035 91.2617V90.4357L128.385 92.3617V93.1877Z",
    fill: "#CDE7FF"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M157.554 109.967L130.523 94.4207V93.5952L157.554 109.142V109.967Z",
    fill: "#E6F3FF"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M168.865 116.476L159.914 111.324V110.498L168.865 115.65V116.476Z",
    fill: "#E6F3FF"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M128.385 95.8979L125.035 93.9719V93.1459L128.385 95.0718V95.8979Z",
    fill: "#CDE7FF"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M157.554 112.674L130.523 97.1273V96.3018L157.554 111.849V112.674Z",
    fill: "#E6F3FF"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M168.865 119.182L159.914 114.03V113.204L168.865 118.356V119.182Z",
    fill: "#E6F3FF"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M128.385 98.6073L125.035 96.6814V95.8554L128.385 97.7819V98.6073Z",
    fill: "#CDE7FF"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M152.054 112.215L130.523 99.8319V99.0064L152.054 111.39V112.215Z",
    fill: "#E6F3FF"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M168.865 121.893L154.258 113.487V112.661L168.865 121.067V121.893Z",
    fill: "#E6F3FF"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M128.385 101.313L125.035 99.3873V98.5613L128.385 100.487V101.313Z",
    fill: "#CDE7FF"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M161.462 120.337L130.523 102.542V101.717L161.462 119.512V120.337Z",
    fill: "#E6F3FF"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M168.865 124.601L159.914 119.449V118.623L168.865 123.775V124.601Z",
    fill: "#E6F3FF"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M128.385 104.023L125.035 102.097V101.271L128.385 103.197V104.023Z",
    fill: "#CDE7FF"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M157.554 120.799L130.523 105.253V104.427L157.554 119.974V120.799Z",
    fill: "#E6F3FF"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M168.865 127.311L159.914 122.159V121.333L168.865 126.486V127.311Z",
    fill: "#E6F3FF"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M128.385 106.733L125.035 104.807V103.981L128.385 105.907V106.733Z",
    fill: "#CDE7FF"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M149.761 119.035L130.523 107.963V107.137L149.761 118.21V119.035Z",
    fill: "#E6F3FF"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M168.865 130.015L167.332 129.129V128.303L168.865 129.189V130.015Z",
    fill: "#E6F3FF"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M165.092 127.847L159.914 124.869V124.044L165.092 127.022V127.847Z",
    fill: "#E6F3FF"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M128.385 109.439L125.035 107.513V106.687L128.385 108.613V109.439Z",
    fill: "#CDE7FF"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M153.423 123.839L130.523 110.669V109.842L153.423 123.013V123.839Z",
    fill: "#E6F3FF"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M168.863 132.726L155.633 125.113V124.287L168.863 131.901V132.726Z",
    fill: "#E6F3FF"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M128.385 112.148L125.035 110.222V109.396L128.385 111.322V112.148Z",
    fill: "#CDE7FF"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M143.446 120.814L130.523 113.382V112.556L143.446 119.989V120.814Z",
    fill: "#E6F3FF"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M168.868 135.435L145.969 122.26V121.434L168.868 134.609V135.435Z",
    fill: "#E6F3FF"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M128.385 114.858L125.035 112.933V112.106L128.385 114.032V114.858Z",
    fill: "#CDE7FF"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M157.554 131.638L130.523 116.091V115.266L157.554 130.813V131.638Z",
    fill: "#E6F3FF"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M168.865 138.143L159.914 132.991V132.165L168.865 137.318V138.143Z",
    fill: "#E6F3FF"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M128.112 69.2633L124.762 67.3373V66.5113L128.112 68.4373V69.2633Z",
    fill: "#CDE7FF"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M157.281 86.0391L130.25 70.4923V69.6668L157.281 85.2136V86.0391Z",
    fill: "#E6F3FF"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M168.592 92.5505L159.641 87.3985V86.5724L168.592 91.7244V92.5505Z",
    fill: "#E6F3FF"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M128.112 71.9713L124.762 70.0453V69.2193L128.112 71.1453V71.9713Z",
    fill: "#CDE7FF"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M157.281 88.7475L130.25 73.2007V72.3753L157.281 87.922V88.7475Z",
    fill: "#E6F3FF"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M168.592 95.2602L159.641 90.1082V89.2822L168.592 94.4342V95.2602Z",
    fill: "#E6F3FF"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M128.112 74.6821L124.762 72.7561V71.9301L128.112 73.8566V74.6821Z",
    fill: "#CDE7FF"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M151.78 88.2946L130.25 75.9112V75.0857L151.78 87.4691V88.2946Z",
    fill: "#E6F3FF"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M168.592 97.9664L153.984 89.5608V88.7348L168.592 97.1403V97.9664Z",
    fill: "#E6F3FF"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M128.112 77.392L124.762 75.4661V74.6401L128.112 76.566V77.392Z",
    fill: "#CDE7FF"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M161.188 96.4165L130.25 78.6215V77.796L161.188 95.591V96.4165Z",
    fill: "#E6F3FF"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M168.592 100.68L159.641 95.5279V94.7019L168.592 99.8539V100.68Z",
    fill: "#E6F3FF"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M128.112 80.0978L124.762 78.1719V77.3459L128.112 79.2718V80.0978Z",
    fill: "#CDE7FF"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M157.281 96.8767L130.25 81.3299V80.5044L157.281 96.0512V96.8767Z",
    fill: "#E6F3FF"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M168.592 103.383L159.641 98.2309V97.4049L168.592 102.557V103.383Z",
    fill: "#E6F3FF"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M128.112 82.8076L124.762 80.8817V80.0557L128.112 81.9816V82.8076Z",
    fill: "#CDE7FF"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M149.488 95.1102L130.25 84.0373V83.2113L149.488 94.2847V95.1102Z",
    fill: "#E6F3FF"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M168.591 106.094L167.059 105.208V104.382L168.591 105.268V106.094Z",
    fill: "#E6F3FF"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M164.819 103.925L159.641 100.947V100.121L164.819 103.099V103.925Z",
    fill: "#E6F3FF"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M128.112 85.5173L124.762 83.5914V82.7653L128.112 84.6913V85.5173Z",
    fill: "#CDE7FF"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M153.149 99.9177L130.25 86.7473V85.9213L153.149 99.0917V99.9177Z",
    fill: "#E6F3FF"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M168.59 108.805L155.359 101.192V100.366L168.59 107.98V108.805Z",
    fill: "#E6F3FF"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M128.112 88.2273L124.762 86.3013V85.4753L128.112 87.4013V88.2273Z",
    fill: "#CDE7FF"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M143.172 96.8891L130.25 89.457V88.6309L143.172 96.0636V96.8891Z",
    fill: "#E6F3FF"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M168.594 111.509L145.695 98.3346V97.5086L168.594 110.684V111.509Z",
    fill: "#E6F3FF"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M128.112 90.9342L124.762 89.0082V88.1822L128.112 90.1082V90.9342Z",
    fill: "#CDE7FF"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M157.281 107.709L130.25 92.1623V91.3369L157.281 106.884V107.709Z",
    fill: "#E6F3FF"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M168.592 114.221L159.641 109.069V108.242L168.592 113.395V114.221Z",
    fill: "#E6F3FF"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M96.287 186.051C96.287 186.051 96.9503 192.894 98.0629 195.258C99.1755 197.622 101.491 197.259 103.277 196.93C105.063 196.602 109.403 193.049 111.487 190.787C113.571 188.525 118.257 188.625 121.621 183.17C124.984 177.714 121.132 175.742 119.96 175.713C118.788 175.684 112.99 180.957 108.04 179.348L96.287 186.051Z",
    fill: "#1B1B39"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M115.846 190.665C115.846 190.665 116.508 197.507 117.62 199.871C118.733 202.236 121.049 201.872 122.835 201.544C124.622 201.215 128.961 197.662 131.045 195.4C133.13 193.138 137.815 193.239 141.179 187.784C144.541 182.328 140.69 180.355 139.518 180.326C138.346 180.296 132.821 185.051 127.871 183.442L115.846 190.665Z",
    fill: "#1B1B39"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M113.908 147.349C111.257 145.709 105.091 146.399 98.0928 148.027C97.0797 146.226 95.8693 144.798 94.3244 143.843C86.4888 138.999 47.9452 154.487 47.9452 154.487C47.9452 154.487 42.9162 175.776 50.2466 180.427C53.0657 182.215 59.1494 180.101 65.5685 176.827C65.7174 176.012 66.0414 175.152 65.999 174.507C71.7253 178.229 77.0527 181.596 83.6146 181.1C86.3111 179.797 89.11 178.242 91.7879 176.648C94.2477 182.813 96.2574 187.156 96.2574 187.156C104.608 187.963 107.351 182.585 108.067 180.627C108.22 180.21 108.207 179.754 108.037 179.343C106.714 176.125 105.668 172.942 104.776 169.871L107.204 168.863C111.047 180.305 115.841 190.662 115.841 190.662C126.019 191.647 127.867 183.441 127.867 183.441C121.085 167.338 121.33 151.938 113.908 147.349Z",
    fill: "#CDE7FF"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1297 117.923C91.1297 117.923 93.7479 111.856 94.6343 111.22C95.5214 110.583 103.133 109.856 103.818 109.695C104.504 109.535 105.989 110.941 105.989 110.941C105.989 110.941 109.911 110.569 110.38 110.654C110.85 110.739 110.878 112.927 109.838 112.998C108.798 113.07 106.848 113.812 106.848 113.812L104.65 117.04C104.65 117.04 100.779 119.952 100.086 119.997C99.3929 120.042 94.6003 121.28 94.6003 121.28L91.1297 117.923Z",
    fill: "#FFCDCA"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6816 120.946C96.6816 120.946 95.7143 115.267 91.6968 115.529L75.0444 120.533C73.5239 117.62 71.0276 115.281 67.9297 113.964L50.9773 106.757C49.2323 106.016 47.3364 105.671 45.4452 105.819C41.9836 106.09 37.029 107.572 35.4459 113.589C32.9282 123.159 45.5804 160.555 45.5804 160.555C45.5804 160.555 56.6007 172.451 64.6203 171.33C72.6399 170.21 83.7891 162.689 83.4174 157.04C83.1618 153.154 79.0801 135.582 76.5549 124.983L83.8007 131.366L96.6816 120.946Z",
    fill: "#0486FE"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2191 209.862C90.8915 209.12 90.1243 208.937 89.2635 209.51C88.8766 209.767 88.5279 210.143 88.2388 210.577L68.0558 202.625L81.897 195.188C81.9413 195.189 81.9862 195.189 82.0324 195.186C82.4035 195.755 83.105 195.856 83.882 195.338C84.9685 194.615 85.7802 192.976 85.6947 191.677C85.6335 190.748 85.1264 190.254 84.4467 190.309C84.0756 189.739 83.3747 189.638 82.5972 190.155C81.5397 190.859 80.7495 192.428 80.7862 193.709L66.0305 199.827L65.5001 191.765L60.8535 192.068L61.3141 199.069L53.5017 194.744L50.9384 195.5L60.6614 202.519L39.4949 208.705C39.3009 208.161 38.8946 207.88 38.3824 207.915C38.0097 207.354 37.3123 207.258 36.5395 207.772C35.453 208.495 34.6414 210.134 34.7268 211.433C34.7876 212.358 35.2891 212.849 35.9627 212.803C36.3354 213.364 37.0328 213.46 37.8056 212.946C38.5094 212.478 39.0928 211.624 39.3968 210.729L61.1484 205.43L60.1717 222.766C59.7401 222.689 59.2632 222.898 58.8478 223.421C58.0358 224.441 57.7669 226.249 58.2476 227.459C58.5268 228.162 58.9986 228.497 59.5032 228.464C59.8996 228.788 60.4852 228.783 61.1233 228.358C62.2099 227.635 63.0215 225.996 62.9361 224.697C62.9124 224.337 62.8171 224.048 62.6762 223.824L65.7091 205.132L87.4966 212.447C87.4581 212.693 87.4355 212.939 87.4508 213.171C87.5152 214.15 88.0712 214.655 88.8063 214.535C89.1334 215.277 89.9012 215.461 90.7614 214.888C91.848 214.165 92.6596 212.526 92.5742 211.227C92.5098 210.248 91.9537 209.743 91.2191 209.862Z",
    fill: "#369EFE"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4922 162.341C63.2586 157.297 53.9352 122.582 30.699 120.889C27.4934 120.659 24.4966 122.578 23.422 125.603C21.2257 131.834 18.511 144.532 22.425 164.063C25.9337 181.605 34.5126 191.332 45.599 195.241C47.455 195.895 49.3159 196.197 51.1258 196.192C51.1215 196.202 51.1157 196.214 51.1114 196.225C57.7018 197.069 64.9943 195.139 65.7621 194.97C87.774 190.197 99.9563 180.232 100.852 172.668C101.257 169.229 89.1723 184.752 75.4744 181.292C65.8349 177.434 64.4922 162.341 64.4922 162.341Z",
    fill: "#B4DBFF"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M100.855 172.665C77.5702 187.93 69.6948 178.427 67.4138 173.761C66.8078 172.521 66.5965 171.623 66.5965 171.623C66.5965 171.623 60.0194 146.586 52.6762 135.318C46.4825 125.813 38.6559 119.734 27.1094 120.14",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7161 103.432L50.9759 106.762L67.9289 113.969L66.3865 108.017L53.7161 103.432Z",
    fill: "#B4DBFF"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M143.628 127.781C141.189 130.015 136.649 131.024 133.489 130.036C130.328 129.048 129.743 126.438 132.182 124.205C134.621 121.971 139.16 120.962 142.321 121.95C145.482 122.938 146.067 125.549 143.628 127.781Z",
    fill: "#FFB94F"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M145.076 124.398L130.738 127.586L128.062 115.644L142.401 112.456L145.076 124.398Z",
    fill: "#FFB94F"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M140.953 115.837C138.514 118.07 133.974 119.08 130.814 118.091C127.653 117.104 127.068 114.493 129.507 112.26C131.947 110.027 136.486 109.018 139.647 110.006C142.807 110.993 143.392 113.603 140.953 115.837Z",
    fill: "white"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M140.88 113.725C140.687 114.174 140.326 114.636 139.787 115.083C137.812 116.718 134.202 117.52 131.716 116.878C131.038 116.702 130.514 116.436 130.153 116.11C129.184 115.244 129.356 113.943 130.793 112.756C132.768 111.122 136.378 110.319 138.864 110.961C140.671 111.427 141.382 112.531 140.88 113.725Z",
    fill: "#F2F6F9"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M140.883 113.726C140.689 114.175 140.329 114.638 139.79 115.084C137.814 116.719 134.204 117.521 131.719 116.879C131.04 116.703 130.517 116.437 130.155 116.111C130.343 115.664 130.703 115.2 131.242 114.753C133.218 113.119 136.828 112.316 139.313 112.959C139.992 113.135 140.516 113.402 140.883 113.726Z",
    fill: "#FFDCA7"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1705 124.528C84.1153 129.497 80.838 134.287 75.851 135.228C70.8636 136.169 66.0549 132.905 65.11 127.936C64.1653 122.968 67.4422 118.178 72.43 117.236C77.417 116.296 82.2256 119.56 83.1705 124.528Z",
    fill: "#0486FE"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M103.627 129.396C103.085 129.405 101.93 129.146 101.424 128.908L78.7497 118.232L71.6264 132.969C71.6264 132.969 70.6254 134.696 72.0462 135.177L101.102 145.002C102.738 145.555 104.457 145.635 106.082 145.287C105.314 139.889 104.7 134.846 103.627 129.396Z",
    fill: "#0486FE"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M125.638 126.585C125.638 126.585 129.225 121.031 130.204 120.549C131.184 120.067 138.812 120.598 139.515 120.553C140.218 120.508 141.45 122.138 141.45 122.138L142.826 123.198C143.694 123.866 143.598 125.199 142.642 125.734C140.992 126.658 139.12 127.934 139.12 127.934C139.12 127.934 134.821 130.17 134.129 130.101C133.438 130.032 128.506 130.466 128.506 130.466L125.638 126.585Z",
    fill: "#FFCDCA"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M112.036 137.277C111.606 141.419 107.978 144.459 103.933 144.066C99.8884 143.673 96.9577 139.997 97.3872 135.855C97.8168 131.713 101.444 128.673 105.489 129.066C109.534 129.459 112.465 133.135 112.036 137.277Z",
    fill: "#0486FE"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M131.414 131.603C131.414 131.603 130.94 126.47 127.144 124.935C126.355 124.615 108.348 129.161 108.348 129.161C107.664 129.384 106.9 129.67 106.229 129.485C105.708 135.015 105.448 140.058 104.648 145.452C106.372 145.582 108.13 145.24 109.719 144.407L131.414 131.603Z",
    fill: "#0486FE"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0352 104.105L67.235 109.506L68.3617 103.516C64.0414 102.595 59.7889 101.513 55.7026 99.7786L55.0352 104.105Z",
    fill: "#FFCDCA"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8321 87.2293C73.9199 87.2123 75.9895 87.3025 77.0848 87.3514C77.4326 87.3668 77.6782 87.693 77.5999 88.0306L77.2189 89.6596C77.0892 90.2167 76.642 90.6451 76.0784 90.754L73.7344 91.205",
    stroke: "#1B1B39",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5528 100.807C69.2395 104.346 66.917 107.769 63.3651 108.452C59.8132 109.136 56.3772 106.823 55.6905 103.284C55.0043 99.7459 57.3268 96.3235 60.8781 95.6394C64.43 94.9552 67.866 97.2689 68.5528 100.807Z",
    fill: "#FFCDCA"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1328 94.3608L55.3912 101.08C59.7336 102.01 64.1153 102.268 68.5323 102.355L68.5278 101.58L71.5691 101.361C73.1447 101.248 74.4541 100.109 74.7793 98.5696L75.8 93.7415C75.9496 93.0332 75.8928 92.2973 75.6366 91.6203L75.3043 90.7426C75.084 90.1607 75.0261 89.5294 75.1365 88.9167L75.3391 87.7992C75.4235 87.3317 75.4208 86.8527 75.3297 86.3864L73.7464 78.2255L55.1328 94.3608Z",
    fill: "#FFCDCA"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8629 74.3773C53.5252 76.6074 51.7879 84.1968 51.7879 84.1968C51.7879 84.1968 49.9325 84.32 49.5399 86.736C49.2225 88.6878 52.6927 96.3278 54.037 99.1892C54.3511 99.858 55.0207 100.284 55.7616 100.291L59.584 100.326C61.5305 100.344 63.3727 99.4494 64.5591 97.9117L68.6818 92.5666L68.9148 93.765L69.6838 93.4603C70.3733 93.187 70.8531 92.5545 70.9293 91.8192L71.6254 85.1351C71.6254 85.1351 76.897 83.6513 77.2127 76.8037C77.2127 76.8037 70.2005 72.1473 61.8629 74.3773Z",
    fill: "#1B1B39"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M68.935 95.3372V91.7713C68.935 91.7713 67.9132 90.2298 66.4182 91.207C64.9238 92.1843 66.4381 96.2672 67.3882 96.2045C68.3382 96.1407 68.935 95.3372 68.935 95.3372Z",
    fill: "#FFCDCA"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9322 91.7738L77.5569 89.5767L77.839 88.0924L68.1328 91.0715L68.9322 91.7738Z",
    fill: "#F2F6F9"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2303 102.328L52.2773 105.472L68.7208 113.768L67.5725 107.728L55.2303 102.328Z",
    fill: "#B4DBFF"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M283 23.9999C283 37.2557 272.254 48.0013 259 48.0013C245.744 48.0013 235 37.2557 235 23.9999C235 10.7449 245.744 0 259 0C272.254 0 283 10.7449 283 23.9999Z",
    fill: "#369EFE"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M259.512 29.7266L259.28 30.1692L259.512 29.7266C259.221 29.5735 258.873 29.5735 258.582 29.7266L258.814 30.1692L258.582 29.7266L252.658 32.8411L253.789 26.2446C253.845 25.9202 253.737 25.5892 253.501 25.3595L248.709 20.6878L255.332 19.7254C255.658 19.678 255.939 19.4735 256.085 19.1783L259.047 13.1767L262.009 19.1783C262.155 19.4735 262.436 19.678 262.762 19.7254L269.385 20.6878L264.592 25.3595C264.357 25.5892 264.249 25.9202 264.305 26.2446L265.436 32.8411L259.512 29.7266Z",
    fill: "white",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteOffers);
export default __webpack_public_path__ + "static/media/favoriteOffers.89081f00.svg";
export { ForwardRef as ReactComponent };